import { Card, Container, Grid } from '@mui/material';
import { Helmet } from 'react-helmet-async';

import Footer from 'src/components/Commons/Footer';
import RefundRateReportContainer from 'src/components/Reports/RefundRateReport/Charts/RefundRateReportContainer';
import PageHeader from 'src/components/Reports/SalesReport/PageHeader';
import useLanguage from 'src/hooks/Language/useLanguage';
import useRefundRateReport from 'src/hooks/Reports/useRefundRateReport';
import BreakCrumbs from 'src/pages/Breakcum';
import { TBreadCrumb } from 'src/types/Breakcrumbs/breadcrumb.model';
import { TRefundRateReportRequest } from 'src/types/Reports/refundRate.model';
import { PathURL } from 'src/utils/constants/path';

export default function RefundRateReport() {
  const { language } = useLanguage();

  const { mutationGetRefundRateByTeam, listRefundReport } = useRefundRateReport();

  const breadcrumb: TBreadCrumb[] = [
    { path: PathURL.dashboard, name: language.dashboard.titleHeader },
    { path: '', name: language.refundRateReport.titleHeader }
  ];

  const handleFindReport = (data: TRefundRateReportRequest) => {
    mutationGetRefundRateByTeam.mutateAsync(data);
  };

  return (
    <>
      <Helmet>
        <title>{language.refundRateReport.titleHeader}</title>
      </Helmet>

      <Container maxWidth="xl" className="pt-16">
        <Grid container direction="row" justifyContent="center" alignItems="stretch" spacing={2}>
          <Grid item xs={12} md={12}>
            {breadcrumb && <BreakCrumbs breadcrumb={breadcrumb} />}
          </Grid>
        </Grid>
        <div className="flex flex-row flex-wrap">
          <Card className="w-full p-8">
            <PageHeader
              onFindReport={handleFindReport}
              isLoading={mutationGetRefundRateByTeam.isLoading}
              title={language.refundRateReport.titleHeader}
            />
            {listRefundReport && listRefundReport.refundRateReportDatas && (
              <RefundRateReportContainer data={listRefundReport} />
            )}
          </Card>
        </div>
      </Container>
      <Footer />
    </>
  );
}
